import { render, staticRenderFns } from "./CalendarPosturasView.vue?vue&type=template&id=1fa5bf42&scoped=true"
import script from "./CalendarPosturasView.vue?vue&type=script&lang=js"
export * from "./CalendarPosturasView.vue?vue&type=script&lang=js"
import style0 from "./CalendarPosturasView.vue?vue&type=style&index=0&id=1fa5bf42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa5bf42",
  null
  
)

export default component.exports